module.exports = __webpack_public_path__ + "img/image36.e755d7b9.jpg";